import React from "react";
import FAQ from "./FAQ";
import "../../../../css/Common/Components/DesignSystem/FAQ.css";

/**
 * Renders a container for Frequently Asked Questions (FAQs).
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Array<{question: string, answer: string}>} props.faqs - An array of FAQ objects, each containing a question and its corresponding answer.
 * @param {boolean} [props.isAdviser=false] - Flag to determine if the FAQs are for advisers. If true, the heading will be "About the Network"; otherwise, it will be "FAQ".
 * @returns {JSX.Element} The rendered FAQ container component.
 */
const FAQContainer = ({ faqs, isAdviser = false }) => {
  return (
    <div className="FAQ-Container">
      <h2>{isAdviser ? "About the Network" : "FAQ"}</h2>
      {faqs.map((faq, index) => (
        <FAQ key={index} question={faq.question} answer={faq.answer} />
      ))}
    </div>
  );
};

export default FAQContainer;
